import { makeRequestAction } from './index';

export const getmunicipalityLeads = makeRequestAction('GET_SEARCH_MUNICIPALITY_LEADS', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
